import DeleteIcon from "@mui/icons-material/Delete";
import {IconButton, useTheme} from "@mui/material";
import ArticleIcon from "@mui/icons-material/Article";
import {observer} from "mobx-react";
import { useEffect, useState } from "react";

const FormFileField = ({
                           title,
                           placeholder,
                           singleFile = true,
                           isRequired = false,
                           form,
                           fieldName,
                           onBlur,
                           readOnly,
                       }) => {
    const theme = useTheme();
    const formField = form ? form.getFieldByName(fieldName) : null;
    const readonly = readOnly !== undefined ? readOnly : (form ? form.isReadonly(fieldName) : false);
    const required = formField ? !formField.isOptional : isRequired;

    const [files, setFiles] = useState(() => {
        if (!formField?.value) return [];
        return Array.isArray(formField.value)
            ? formField.value
            : [formField.value];
    });

    useEffect(() => {
        if (formField?.value) {
            const initialFiles = Array.isArray(formField.value)
                ? formField.value
                : [formField.value];
            setFiles(initialFiles);
        }
    }, [formField?.value]);

    const handleChange = async (event) => {
        const selectedFiles = Array.from(event.target.files);
        setFiles(singleFile ? [selectedFiles[0]] : selectedFiles);

        if (formField) {
            await form.updateFieldWithValue(fieldName, singleFile ? selectedFiles[0] : selectedFiles);
        }
        onBlur?.();
    };

    const handleRemove = async (index) => {
        const newFiles = files.filter((_, i) => i !== index);
        setFiles(newFiles);
        if (formField) {
            await form.updateFieldWithValue(fieldName, singleFile ? newFiles[0] || {name: null, url: null} : newFiles);
        }
        onBlur?.();
    };
    const hasFiles = !!formField?.value && !!formField.value.name;

    return (
        <div className="mb-4 text-start">
            <p style={{ fontSize: "14px" }}>
                {title}
                {required && <span style={{ color: theme.palette.error.main, marginLeft: "5px" }}>*</span>}
            </p>

            {!hasFiles && (
                <label
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        border: required && !hasFiles ? `2px solid ${theme.palette.error.main}` : `1px solid ${theme.palette.divider}`,
                        borderRadius: "5px",
                        padding: "20px",
                        backgroundColor: theme.brand.field,
                        cursor: !readonly && "pointer",
                        marginBottom: "1em",
                        width: "100%",
                        boxSizing: "border-box",
                        minWidth: 0,
                    }}
                >
                    <input
                        type="file"
                        style={{ display: "none" }}
                        multiple={!singleFile}
                        accept=".pdf,.jpg,.jpeg,.png,.docx"
                        onChange={handleChange}
                        disabled={readonly}
                    />
                    <ArticleIcon sx={{ color: required && !hasFiles ? theme.palette.error.main : theme.palette.text.secondary, marginRight: "10px", flexShrink: 0 }} />
                    <span
                        style={{
                            color: required && !hasFiles ? theme.palette.error.main : theme.palette.text.secondary,
                            fontWeight: required && !hasFiles ? "bold" : "normal",
                            flex: 1,
                            minWidth: 0,
                            overflowWrap: "break-word",
                            wordBreak: "break-word",
                            textAlign: "center",
                        }}
                    >
            {hasFiles
                ? singleFile
                    ? "1 archivo seleccionado"
                    : `${files.length} archivo(s) seleccionado(s)`
                : placeholder}
          </span>
                </label>
            )}

            {hasFiles && (
                <div style={{ paddingLeft: "1em", fontSize: "14px" }}>
                    <ul style={{ listStyleType: "none", padding: 0 }}>
                        {files.map((file, index) => {
                            const urlToOpen = file instanceof File
                                ? URL.createObjectURL(file)
                                : (file?.url || null);
                            return (
                            <li
                                key={`${fieldName}-${index}-${file?.name ?? ''}`}
                                style={{
                                    marginBottom: "0.5em",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                <span
                    onClick={() => {
                        if (urlToOpen) {
                            window.open(urlToOpen, "_blank");
                            if (file instanceof File) {
                                setTimeout(() => URL.revokeObjectURL(urlToOpen), 60000);
                            }
                        }
                    }}
                    style={{
                        maxWidth: "200px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        cursor: urlToOpen ? "pointer" : "default",
                    }}
                >
                  {file?.name}
                </span>

                                {!readonly && <IconButton
                                    size="small"
                                    onClick={async () => await handleRemove(index)}
                                    sx={{ color: 'error.main', padding: "2px" }}
                                >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                                }
                            </li>
                            );
                        })}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default observer(FormFileField);
